import { ETourId, type ITourConfig } from '../types';

/**
 * Exception highlight tour shown when the first exception occurs during a draft run.
 *
 * Two steps guiding the user through what happened:
 * 1. We hit a small speed bump — the highlighted exception line in the AOP editor
 * 2. Your Resolution Agent is on it — the GuidanceOverlay QuestionCard
 */
export const exceptionHighlightTour: ITourConfig = {
  id: ETourId.EXCEPTION_HIGHLIGHT,
  steps: [
    {
      id: 'exception-line',
      target: '.paragraph-highlight-exception',
      titleKey: 'tours.exceptionResolution.exceptionLine.title',
      descriptionKey: 'tours.exceptionResolution.exceptionLine.description',
      finishLabelKey: 'tours.exceptionResolution.exceptionLine.finishLabel',
      position: 'topLeft',
    },
    // TODO: Enable this when the collapsed view of the Resolution Agent shows up when resolving under the hood
    // {
    //   id: 'resolution-agent-card',
    //   target: '[data-tour-id="guidance-question-card"]',
    //   titleKey: 'tours.exceptionResolution.resolutionAgentCard.title',
    //   descriptionKey:
    //     'tours.exceptionResolution.resolutionAgentCard.description',
    //   finishLabelKey:
    //     'tours.exceptionResolution.resolutionAgentCard.finishLabel',
    //   position: 'leftTop',
    // },
    {
      id: 'resolution-agent-card-resolved',
      target: '[data-tour-id="guidance-question-card"]',
      titleKey: 'tours.exceptionResolution.resolutionAgentCardResolved.title',
      descriptionKey:
        'tours.exceptionResolution.resolutionAgentCardResolved.description',
      finishLabelKey:
        'tours.exceptionResolution.resolutionAgentCardResolved.finishLabel',
      position: 'leftTop',
    },
    {
      id: 'run-detail-review',
      target: '[data-tour-id="run-assistant-toolbar-button"]',
      titleKey: 'tours.exceptionResolution.runDetailReview.title',
      descriptionKey: 'tours.exceptionResolution.runDetailReview.description',
      finishLabelKey: 'tours.exceptionResolution.runDetailReview.finishLabel',
      position: 'topLeft',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_exception_highlight',
    metadata: {
      tourName: 'Exception Highlight',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
